import * as React from 'react'
import { GDataContext, GDataContextManager } from '../GDataContext';
import { GraphDataset } from '../models/GraphDataset.interface';
import { ZeroBaseFeeSettingsContext } from './ZeroBaseFeeSettings';


type Props = {
  children: any,
}


const GDataPrunedProvider = ({
  children,
}: Props) => {
  const settings = React.useContext(ZeroBaseFeeSettingsContext);
  const [pruned, setPruned] = React.useState<GraphDataset>(null);
  const baseGraphContext = React.useContext(GDataContext);


  if (!baseGraphContext) {
    throw new Error('GDataZeroBaseFeeProvider requires WholeGraphProvider to provide data as a parent.');
  }

  function addNodeZeroBaseFeeFlag() {
    for (const node of baseGraphContext.dataset.nodes) {
      const outEdges = baseGraphContext.getOutboundEdges(node.id);
      const nonZeroFeeEdges = outEdges.filter(edge => edge.baseFeeMsat !== 0);
      const percentage = 1 - nonZeroFeeEdges.length / outEdges.length;

      (node as any).isZeroBaseFee = percentage >= 0.85;
    }
  }

  function pruneEdges(dataset: GraphDataset) {

    const edges = dataset.edges.filter(edge => {
      if (settings.zeroEnabled && settings.nonZeroEnabled) {
        return true;
      } else if (settings.zeroEnabled && !settings.nonZeroEnabled) {
        return edge.baseFeeMsat === 0;
      } else if (!settings.zeroEnabled && settings.nonZeroEnabled) {
        return edge.baseFeeMsat > 0;
      }
    });

    const nodeEdgesCount = new Map<string, number>();

    function addOne(nodeId) {
      if (!nodeEdgesCount.has(nodeId)) {
        nodeEdgesCount.set(nodeId, 0);
      }
      const current = nodeEdgesCount.get(nodeId);
      nodeEdgesCount.set(nodeId, current + 1);
    }
    edges.forEach(e => {
      addOne(e.source);
      addOne(e.target);
    })

    const nodes = dataset.nodes.filter(n => {
      return nodeEdgesCount.has(n.id) && nodeEdgesCount.get(n.id) > 0;
    })

    return {
      edges: edges,
      nodes: nodes,
    }
  }


  React.useEffect(() => {
    if (!baseGraphContext.dataset) {
      setPruned(undefined);
      return;
    }
    addNodeZeroBaseFeeFlag();
    const pruned = pruneEdges(baseGraphContext.dataset)
    setPruned(pruned)
  }, [baseGraphContext.dataset, settings.nonZeroEnabled, settings.zeroEnabled])

  return (
    <GDataContext.Provider value={new GDataContextManager(pruned, baseGraphContext.createdAt, baseGraphContext.hasError, baseGraphContext.retry)}>
      {children}
    </GDataContext.Provider>
  );
};

export default GDataPrunedProvider;